export const SET_BOT_RADAR_PLATFORM = 'SET_BOT_RADAR_PLATFORM';
export const SET_UPVSDOWN_PLATFORM = 'SET_UPVSDOWN_PLATFORM';
export const SET_SPORT_PLATFORM = 'SET_SPORT_PLATFORM';

export const set_bot_radar_platform = (value) => ({
    type: SET_BOT_RADAR_PLATFORM,
    payload: value
})

export const set_upvsdown_platform = (value) => ({
    type: SET_UPVSDOWN_PLATFORM,
    payload: value
})

export const set_sport_platform = (value) => ({
    type: SET_SPORT_PLATFORM,
    payload: value
})